import React, { useEffect, useState } from "react";
import { useT } from "@/i18n/i18n";
import api from "@/lib/api";
import { DemoBadge, RiskBadge } from "@/components/shared";

export default function PublicRescue() {
  const { lang } = useT();
  const L = (pl, en) => (lang === "pl" ? pl : en);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/public/rescue").then((r) => setRows(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div className="mx-auto max-w-7xl px-4 py-16">
      <div className="flex items-center gap-3">
        <h1 className="font-heading text-3xl font-bold text-charcoal sm:text-4xl">Ratunek dla Plonu</h1>
        <DemoBadge />
      </div>
      <p className="mt-3 max-w-2xl text-mutedtext">{L("Podgląd plonów zagrożonych na podstawie danych demonstracyjnych. Dane prywatne rolników nie są ujawniane.", "Crop-at-risk preview using demonstration data only. Farmers' private information is not shown.")}</p>

      {loading ? <p className="mt-10 text-mutedtext">…</p> : (
        <div className="mt-8 grid gap-5 md:grid-cols-2 lg:grid-cols-3">
          {rows.length === 0 && <p className="text-mutedtext">{L("Brak plonów zagrożonych.", "No crops at risk.")}</p>}
          {rows.map((c, i) => {
            const remaining = c.risk.remaining;
            return (
              <div key={i} className="rounded-md border border-subtle bg-white p-5" data-testid={`rescue-card-${i}`}>
                <div className="flex items-start justify-between">
                  <div>
                    <div className="font-heading text-lg font-bold text-charcoal">{c.product}{c.variety ? ` — ${c.variety}` : ""}</div>
                    <div className="text-sm text-mutedtext capitalize">{c.region}</div>
                  </div>
                  <RiskBadge priority={c.risk.priority} />
                </div>
                <dl className="mt-4 space-y-1.5 text-sm">
                  <Row label={L("Oczekiwana ilość", "Expected quantity")} value={`${c.expected_quantity?.toLocaleString()} ${c.quantity_unit}`} />
                  <Row label={L("Dni do zbioru", "Days to harvest")} value={c.risk.days_to_harvest} />
                  <Row label={L("Min. cena", "Min. price")} value={`${c.min_viable_price} PLN/${c.quantity_unit}`} />
                  <Row label={L("Świeże dopasowane", "Fresh matched")} value={`${(c.matched_fresh || 0).toLocaleString()} ${c.quantity_unit}`} />
                  <Row label={L("Przetwórstwo", "Processing")} value={`${(c.matched_processing || 0).toLocaleString()} ${c.quantity_unit}`} />
                  <Row label={L("Pozostało (ryzyko)", "Remaining at risk")} value={<span className="font-semibold text-crittext">{remaining.toLocaleString()} {c.quantity_unit}</span>} />
                </dl>
                <ul className="mt-3 space-y-1 border-t border-subtle pt-3 text-xs text-mutedtext">
                  {c.risk.reasons.slice(0, 3).map((r, j) => <li key={j}>• {r}</li>)}
                </ul>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

function Row({ label, value }) {
  return <div className="flex justify-between gap-4"><dt className="text-mutedtext">{label}</dt><dd className="text-charcoal">{value}</dd></div>;
}
